import { MutationCache, QueryClient } from '@tanstack/react-query';
import i18n from 'i18next';
import { mapApiError } from './errors.js';
import { toast } from './toast.js';

// Zentral: JEDER Mutation-Fehler -> übersetzter Fehler-Toast (app-weit, ohne Zutun der Aufrufstelle).
// Erfolg -> Toast nur wenn die Mutation `meta.successToast` (i18n-Key) deklariert (opt-in).
// Ausnahme: `meta.errorToast: false` (opt-out) — für Mutationen, die ihren Fehler bereits selbst
// sichtbar machen (CatalogTable: Zeile bleibt offen, Feld wird markiert, Spec Kapitel 2 „Fehler").
// Ohne das Opt-out liefe derselbe Fehler doppelt: einmal namentlich in der Zeile, einmal generisch
// im Toast (#52-Review Finding 1).
// #108: networkMode 'always' NUR für Queries — ein Offline-Fetch feuert wirklich, scheitert
// mit TypeError und landet in isError (Fehlerkarte statt Leerzustand). Mutationen bleiben beim
// Default 'online': Schreibaktionen sollen bei Verbindungsabriss warten und beim online-Event
// durchlaufen, statt sofort als Fehler-Toast zu platzen (zentraler MutationCache-onError).
export const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, networkMode: 'always' } },
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      if (mutation.meta?.errorToast === false) return;
      toast.error(mapApiError((k) => i18n.t(k), err));
    },
    onSuccess: (_data, _vars, _ctx, mutation) => {
      const key = mutation.meta?.successToast;
      if (typeof key === 'string') toast.success(i18n.t(key));
    },
  }),
});
